module.exports = __webpack_public_path__ + "static/kom1-115c1e61a8e20fbdebc67712c81c4412.png";